var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConnectivityinline = function SvgConnectivityinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E0E5EB",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M70 40 19 9v62l51-31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6EBFF",
    d: "M58.56 22.112a2 2 0 0 1 0 1.777L56.272 28.5l-2.176 4.389A2 2 0 0 1 52.305 34h-10.61a2 2 0 0 1-1.792-1.111l-4.462-9a2 2 0 0 1 0-1.777l4.462-9A2 2 0 0 1 41.695 12h10.61a2 2 0 0 1 1.792 1.111l4.462 9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0080FF",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M47 12h-5.305a2 2 0 0 0-1.792 1.111l-4.462 9a2 2 0 0 0 0 1.777l4.462 9A2 2 0 0 0 41.695 34h10.61a2 2 0 0 0 1.792-1.111l2.176-4.389M47 12h5.305a2 2 0 0 1 1.792 1.111l4.462 9a2 2 0 0 1 0 1.777L56.273 28.5M47 12l9.273 16.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6FFFC",
    d: "M58.56 56.112a2 2 0 0 1 0 1.776L56.272 62.5l-2.176 4.388A2 2 0 0 1 52.305 68h-10.61a2 2 0 0 1-1.792-1.112l-4.462-9a2 2 0 0 1 0-1.776l4.462-9A2 2 0 0 1 41.695 46h10.61a2 2 0 0 1 1.792 1.111l4.462 9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00877C",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M47 46h-5.305a2 2 0 0 0-1.792 1.111l-4.462 9a2 2 0 0 0 0 1.778l4.462 9A2 2 0 0 0 41.695 68h10.61a2 2 0 0 0 1.792-1.112l2.176-4.388M47 46h5.305a2 2 0 0 1 1.792 1.111l4.462 9a2 2 0 0 1 0 1.778L56.273 62.5M47 46l9.273 16.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDADA",
    d: "M29.56 39.112a2 2 0 0 1 0 1.776L27.272 45.5l-2.176 4.389A2 2 0 0 1 23.305 51h-10.61a2 2 0 0 1-1.792-1.111l-4.462-9a2 2 0 0 1 0-1.778l4.462-9A2 2 0 0 1 12.695 29h10.61a2 2 0 0 1 1.792 1.111l4.462 9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 29h-5.305a2 2 0 0 0-1.792 1.111l-4.462 9a2 2 0 0 0 0 1.778l4.462 9A2 2 0 0 0 12.695 51h10.61a2 2 0 0 0 1.792-1.111l2.176-4.389M18 29h5.305a2 2 0 0 1 1.792 1.111l4.462 9a2 2 0 0 1 0 1.778L27.273 45.5M18 29l9.273 16.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 4,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 71,
    r: 4,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 40,
    r: 4,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })));
};
export default SvgConnectivityinline;